import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [{
    path: "/",
    name: "root",
    // 重定向
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/HomePage/HomePage.vue"),
    meta: {
      KeepAlive: true
    }
  },
  {
    path: "/detail/:stone_type/:stone_no/:thickness/:processing_surface/:mark/:warehouse_id?",
    name: "StoneDetailPage",
    component: () => import("../views/StoneDetailPage/StoneDetailPage.vue"),
    meta: {
      keepAlive: false
    } // 确保不缓存组件
  },
  {
    path: '/stone_type',
    name: 'StoneTypePage',
    component: () => import('@/views/StoneTypePage/StoneTypePage.vue'),
    props: true,
    meta: {
      keepAlive: true
    }
  },
];
const router = new VueRouter({
  // mode: "history",
  //   base: process.env.BASE_URL,
  routes,
});
export default router;
